import { useTranslation } from "react-i18next";

function LinkImage({ image = "" }: { image: string }) {
  const { t } = useTranslation();

  return <img src={image} alt={t("image_picker_user_image_alt")} className="max-h-full" />;
}

export default LinkImage;
